/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { Component } from 'react'
import { off, on } from 'local-storage'

import LocalStorageKey from '@modules/utils/localStorageKeys'

import type { ConsoleRequestState } from '../../../reducers/apiConsole'

type Props = {
  setAPIConsoleRequestHistory: (history: ConsoleRequestState[]) => void
}

type NullableHistory = ConsoleRequestState[] | null

export default class CrossTabHistoryReplication extends Component<Props> {
  componentDidMount() {
    on<NullableHistory>(LocalStorageKey.apiConsoleHistory, this.onChange)
  }

  componentWillUnmount() {
    off<NullableHistory>(LocalStorageKey.apiConsoleHistory, this.onChange)
  }

  render() {
    return null
  }

  onChange = (currentHistory) => {
    this.props.setAPIConsoleRequestHistory(currentHistory)
  }
}
